import { useContext, useEffect, useState } from 'react'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { FlexRow, SideBarContainer, SideBarMenuWrapper, SideBarShadow } from "src/style"
import { sideBarData } from './sidebarData'
import { SidebarMenu } from './sidebarMenu'
import { Logo } from "src/assets/icons"
import { useTranslation } from 'react-i18next'


export const Sidebar: React.FC = () => {
    const {visibility, showSideBar} = useContext(VisibilityContext)
    const {info: {sidebarMenuType, userType, qoreStaffType}} = useContext(AppInfoContext)
    const [menuCategory, setMenuCategory] = useState(sidebarMenuType)
    const [userAccess, setUserAccess] = useState(userType)
      const { t } = useTranslation();



    useEffect(() => {
        if (sidebarMenuType) setMenuCategory(sidebarMenuType)
        if (userType) setUserAccess(userType)
    }, [sidebarMenuType, userType])

    return (
        <>
            <SideBarShadow isSideBar={visibility.isSideBar} onClick={() => showSideBar(false)}/>
            <SideBarContainer isSideBar={visibility.isSideBar}>
                <FlexRow justifyContent="flex-end" className='menu-wrapper'  >
                    <SideBarMenuWrapper>
                        <Logo className="header-logo sidebar-logo" />
                        {
                            sideBarData(t, qoreStaffType).map((menu, index) => {
                                return ((menu.menuCategory === menuCategory && menu.accessType.includes(userAccess)) ? <SidebarMenu item={menu} key={index} /> : null)
                            })
                        }
                    </SideBarMenuWrapper>
                </FlexRow>
            </SideBarContainer>
        </>
    )
}